import { useState } from "react";
import { foApi } from "@/webapp/fleet-owners/api";
import { errorText } from "@/lib/api";
import { PageHead, Panel, Tag, Button, Label, Field, Select, Notice, when } from "@/webapp/fleet-owners/ui";

function ConnectForm({ reload }) {
  const [form, setForm] = useState({ provider: "samsara", api_token: "", username: "", password: "", database: "", server: "", label: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const connect = async () => {
    setBusy(true); setErr("");
    try { await foApi.connect(form); await reload(); } catch (e) { setErr(errorText(e)); }
    setBusy(false);
  };
  return (
    <Panel className="fo-rise fo-rise-1 p-6" testid="fo-conn-form">
      <div className="grid gap-4 sm:grid-cols-2">
        <div><Label>Provider</Label><Select data-testid="fo-conn-provider" value={form.provider} onChange={set("provider")}><option value="samsara">Samsara</option><option value="geotab">Geotab</option></Select></div>
        <div><Label>Label</Label><Field data-testid="fo-conn-label" value={form.label} onChange={set("label")} placeholder="Main fleet" /></div>
        {form.provider === "samsara" ? (
          <div className="sm:col-span-2"><Label>Read-only API token</Label><Field data-testid="fo-conn-token" type="password" autoComplete="off" value={form.api_token} onChange={set("api_token")} placeholder="samsara_api_…" /></div>
        ) : (
          <>
            <div><Label>Username</Label><Field data-testid="fo-conn-username" autoComplete="off" value={form.username} onChange={set("username")} /></div>
            <div><Label>Password</Label><Field data-testid="fo-conn-password" type="password" autoComplete="off" value={form.password} onChange={set("password")} /></div>
            <div><Label>Database</Label><Field data-testid="fo-conn-database" value={form.database} onChange={set("database")} /></div>
            <div><Label>Server (optional)</Label><Field data-testid="fo-conn-server" value={form.server} onChange={set("server")} placeholder="https://my.geotab.com" /></div>
          </>
        )}
      </div>
      {err && <div className="mt-4"><Notice testid="fo-conn-error">{err}</Notice></div>}
      <div className="mt-5 flex items-center gap-3">
        <Button variant="primary" testid="fo-conn-submit" onClick={connect} disabled={busy}>{busy ? "Testing connection…" : "Test and connect"}</Button>
        <p className="text-xs text-slate-400">Credentials are tested live first, then stored AES-256-GCM encrypted in an isolated vault. They are never shown again.</p>
      </div>
    </Panel>
  );
}

export default function Connections({ data, reload }) {
  const t = data.telematics;
  const disconnect = async () => { if (window.confirm("Disconnect telematics?")) { await foApi.disconnect(); await reload(); } };
  return (
    <>
      <PageHead eyebrow="System" title="Telematics" sub="Connect one provider per fleet. Data is read-only and only visible to your account. Powers live positions, hours-of-service and detention detection." />
      {t.connected ? (
        <Panel className="fo-rise fo-rise-1 fo-live-ring flex flex-wrap items-center justify-between gap-4 p-6" testid="fo-conn-status">
          <div>
            <p className="font-display text-lg font-semibold capitalize text-[#0A234A]">{t.provider}{t.label ? ` · ${t.label}` : ""}</p>
            <p className="text-sm text-slate-500">Connected · updated <span className="font-mono">{when(t.updated_at)}</span></p>
          </div>
          <div className="flex items-center gap-3"><Tag tone="ok">Live</Tag><Button variant="danger" testid="fo-conn-disconnect" onClick={disconnect}>Disconnect</Button></div>
        </Panel>
      ) : <ConnectForm reload={reload} />}
    </>
  );
}
